import React, { Component } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { stripHTML } from "../../../../utils/Utils";
import { Container } from "semantic-ui-react";
import MessageSender from "./MessageSender";
import swal from "sweetalert";
class DuvidasEditarSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: "",
      id_pessoa: null,
      id_duvida: null,
      id_local: JSON.parse(localStorage.getItem("USER_NODE")).id,
      admin: false,
    };
  }

  componentDidMount() {
    this.verifyAmin();
    const { idResposta } = this.props;
    api.get(`ticket/resposta/${idResposta}`).then(({ data }) => {
      if (data.id_pessoa !== this.state.id_local && this.state.admin !== true) {
        swal("Você não tem permissão!", "", "error");
        window.location.href = `/`;
        return;
      }
      this.setState({
        content: data.mensagem,
        id_pessoa: data.id_pessoa,
        id_duvida: data.id_duvida,
      });
    });
  }
  verifyAmin = async () => {
    await api
      .post("admin/auth")
      .then((res) => {
        this.setState({ admin: true });
      })
      .catch((err) => {
        this.setState({ admin: false });
      });
  };

  sendResposta = async (mensagem) => {
    if (!stripHTML(mensagem)) {
      swal(
        "Ops! Resposta não Editada ! :(",
        "Por favor, coloque algum texto",
        "error"
      );

      return;
    }
    const { id_pessoa, id_duvida } = this.state;
    const { idResposta } = this.props;
    const data = {
      id_pessoa,
      id_duvida,
      mensagem,
      url: "",
    };

    api
      .put(`ticket/resposta/${idResposta}`, data)
      .then(({ data }) => {
        swal(
          "Alteração concluída !",
          "Alteração na resposta foi bem sucedida.",
          "success"
        );
        window.open(
          `https://www.voitto.com.br/online/tickets/${id_duvida}`,
          "_self"
        );
      })
      .catch(() => {
        swal("Alteração não concluída !", "Alteração falhou.", "error");
      });
  };

  render() {
    const { content } = this.state;
    return (
      content && (
        <div
          style={{ marginTop: "5rem", marginBottom: "2rem", height: "100%" }}
        >
          <Container>
            <h2 style={{ fontFamily: "Montserrat" }}>
              Editar Ticket #{this.props.idResposta}
            </h2>
            <MessageSender
              sendResposta={(mensagem) => this.sendResposta(mensagem)}
              value={content}
            />
          </Container>
        </div>
      )
    );
  }
}

export default DuvidasEditarSection;
